import { create } from "zustand";
import { TaskFormValues } from "../../../features/aufgaben";

interface PendingTaskCreateState {
  values: TaskFormValues | null;
  set: (values: TaskFormValues) => void;
  clear: () => void;
}

export const usePendingTaskCreateStore = create<PendingTaskCreateState>((set) => ({
  values: null,
  set: (values) => set({ values }),
  clear: () => set({ values: null }),
}));
